import { BooleanInput } from '@angular/cdk/coercion';
import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BrnSelectContent } from '@spartan-ng/brain/select';
import { classes, hlm } from '@spartan-ng/helm/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ClassValue } from 'clsx';
import { HlmSelectScrollDown } from './hlm-select-scroll-down';
import { HlmSelectScrollUp } from './hlm-select-scroll-up';

const selectContentVariants = cva(
  'bg-popover no-scrollbar text-popover-foreground data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 data-closed:zoom-out-95 data-open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ring-foreground/5 dark:ring-foreground/10 max-h-72 min-w-36 flex-col rounded-3xl shadow-lg ring-1 duration-100 relative flex w-(--brn-select-width) overflow-x-hidden overflow-y-auto',
  {
    variants: {
      variant: {
        default: '',
        'surface-secondary': 'p-1.5',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export type SelectContentVariants = VariantProps<typeof selectContentVariants>;

@Component({
  selector: 'hlm-select-content',
  imports: [HlmSelectScrollUp, HlmSelectScrollDown],
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [BrnSelectContent],
  template: `
    @if (showScroll()) {
      <hlm-select-scroll-up />
    }

    <div role="listbox" class="flex flex-col">
      <ng-content />
    </div>

    @if (showScroll()) {
      <hlm-select-scroll-down />
    }
  `,
})
export class HlmSelectContent {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  public readonly showScroll = input<boolean, BooleanInput>(false, { transform: booleanAttribute });

  public readonly variant = input<SelectContentVariants['variant']>('default');

  constructor() {
    classes(() => [hlm(selectContentVariants({ variant: this.variant() })), this.userClass()]);
  }
}
